export default {
    carregando: false,
    items: [],
    selecionado: {},
    tarefasDestino: [],
    mobilidadesTarefa: [],
    mobilidadesFormulario: [],
    carregandoMobilidadeFormulario: false,
    opcoesFormulario: [],
    carregandoOpcoesFormulario: false
}